export enum StatusDotTypeEnum {
    N = 'N',
    G = 'G',
    V = 'V',
    O = 'O',
    H = 'H',
}
